// Allows overriding of functions
// See example below, can be used on any JS function
//


Function.prototype.override = function (func) {
	if (func != undefined) {
		func.baseFunc = this;
		func.base = function() { return func.baseFunc.apply(this, arguments); };
		return function() {
			this.base = func.base;
			return func.apply(this, arguments);
		}
	}
}

$(document).ready(function () {
	// Not sure why, but these mcdropdowns don't align correctly when using the new jquery
	// Switching overflow to hidden fixes it, but applying it by stylesheet doesn't.
	/*
	$.fn.mcDropdown = $.fn.mcDropdown.override(function(list, options) {
	var result = this.base(list, options);
	$('div .mcdropdown').parent().css('overflow', 'hidden');
	return result;
	});*/

});